import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// NEXTMIND INFISSI — full multilingual UI. Italian (base.it.json) is the source of truth;
// every other locale is a real translation generated at build-time (scripts/translate_ui.py)
// and stored in ./locales/<code>.json. English is the safety fallback for accidental gaps.

export const LANGS = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "ro", label: "Română", flag: "🇷🇴" },
  { code: "sq", label: "Shqip", flag: "🇦🇱" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "uk", label: "Українська", flag: "🇺🇦" },
  { code: "bg", label: "Български", flag: "🇧🇬" },
  { code: "cs", label: "Čeština", flag: "🇨🇿" },
  { code: "sk", label: "Slovenčina", flag: "🇸🇰" },
  { code: "hu", label: "Magyar", flag: "🇭🇺" },
  { code: "hr", label: "Hrvatski", flag: "🇭🇷" },
  { code: "sr", label: "Srpski", flag: "🇷🇸" },
  { code: "sl", label: "Slovenščina", flag: "🇸🇮" },
  { code: "el", label: "Ελληνικά", flag: "🇬🇷" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "zh-CN", label: "中文简体", flag: "🇨🇳" },
  { code: "zh-TW", label: "中文繁體", flag: "🇹🇼" },
];

export const RTL_LANGS = ["ar"];

// Load every ./locales/<code>.json at build time.
const ctx = require.context("./locales", false, /\.json$/);
const resources = {};
ctx.keys().forEach((path) => {
  const m = path.match(/\.\/(.+)\.json$/);
  if (!m) return;
  const code = m[1];
  if (code === "base.it") return; // source template, not a locale
  resources[code] = { translation: ctx(path) };
});

export function applyDir(lng) {
  const dir = RTL_LANGS.includes(lng) ? "rtl" : "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lng);
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: LANGS.map((l) => l.code),
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "nm_locale",
      convertDetectedLanguage: (lng) => String(lng || "").split("@")[0].split(".")[0].replace("_", "-") },
  });

const isValidTag = (l) => { try { new Intl.Locale(l); return true; } catch { return false; } };
i18n.on("languageChanged", (l) => { if (!isValidTag(l)) { i18n.changeLanguage("it"); return; } applyDir(l); });
if (!isValidTag(i18n.language)) i18n.changeLanguage("it"); else applyDir(i18n.language);

export default i18n;
